// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"px_a bhh_sl bhh_uy","ForumSearch__img":"px_b","ForumSearch__searchAdsAndShoppingAds":"px_c","ForumSearch__results--empty":"px_e"};